// Menyamakan warna status bar (Android) / navigation bar dengan warna latar
// halaman yang sedang aktif, supaya tidak terlihat sebagai bar solid yang
// kontras — melainkan menyatu (seolah "transparan") dengan konten di
// belakangnya. Dipanggil setiap kali mode gelap/terang berubah.

const LIGHT_BG = '#FFFEF7';
const DARK_BG = '#0a0a0a';

export function syncStatusBarColor(isDark) {
  const color = isDark ? DARK_BG : LIGHT_BG;

  // Meta theme-color tanpa atribut `media` akan selalu menang atas yang
  // punya `media`, jadi ini otomatis mengikuti pilihan manual user
  // (bukan cuma preferensi sistem).
  let meta = document.querySelector('meta[name="theme-color"]:not([media])');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'theme-color');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', color);

  document.documentElement.style.backgroundColor = color;
  document.body.style.backgroundColor = color;
}
